const translations = {
    cta: 'Click to add photos',
    fileTooLarge: '{{fileName}} is larger than {{maxFileSizeMegabytes}} MB',
    formats: 'JPEG, PNG, or HEIC',
    tooManyFiles: '{{fileName}} exceeds the limit of {{maxFileCount}} photos',
    unsupportedType: '{{fileName}} is not a JPEG, PNG, or HEIC image'
};

export default translations;
